import { IBase, ILoyaltyByLevel, IPack, LoyaltyEarningMode, LoyaltyType, OrderMode } from "@app/common";

export type LoyaltyFormValues = Omit<ILoyaltyByLevel, keyof IBase | 'levels'> & {
  levels: {
    pack: Pick<IPack, '_id'>;
    loyaltyPointsNeeded: number;
  }[];
};

export const transformLoyaltyFormValuesToPayload = (values: LoyaltyFormValues): Omit<ILoyaltyByLevel, keyof IBase> => {
  return {
    ...values,
    minPrice: values.minPrice ?? 0,
    levels: values.levels?.map((level) => ({
      packId: level.pack._id,
      loyaltyPointsNeeded: Number(level.loyaltyPointsNeeded),
    })) || [],
  }
}

export const transformToUpdatableFormLoyalty = (loyalty?: Partial<ILoyaltyByLevel>): LoyaltyFormValues => {
  return {
    ...loyalty,
    type: loyalty?.type ?? LoyaltyType.LEVEL,
    exchangeRateForOneEuro: loyalty?.exchangeRateForOneEuro ?? 1,
    roundPointsUp: Boolean(loyalty?.roundPointsUp),
    maxPoints: loyalty?.maxPoints ?? 200,
    daysWithoutOrderUntilReset: loyalty?.daysWithoutOrderUntilReset ?? 365,
    orderModes: loyalty?.orderModes ?? [OrderMode.TAKEAWAY, OrderMode.DELIVERY],
    usableOnlyOnNextOrder: Boolean(loyalty?.usableOnlyOnNextOrder) ?? true,
    byShop: Boolean(loyalty?.byShop) ?? false,
    cumulative: Boolean(loyalty?.cumulative) ?? false,
    isUsableOnPOS: Boolean(loyalty?.isUsableOnPOS) ?? false,
    disabled: Boolean(loyalty?.disabled) ?? true,
    earningMode: loyalty?.earningMode ?? LoyaltyEarningMode.EURO,
    minPrice: loyalty?.minPrice ?? 1000,
    // @ts-expect-error
    levels: loyalty?.levels ?? [],
  }
}
